import { Card } from '@yleisradio/areena-types';

export function getPreferredCard(
  card: Card,
  regionalPreferences: Record<string, string>
): Card {
  if (!card.persistentState || !card.cards?.length) return card;

  const regionalChannel = regionalPreferences[card.persistentState.key];

  return (
    card.cards.find(c => c.persistentState?.id === regionalChannel) ??
    (card.cards[0] as Card) // the cards-list length restriction above makes this defined
  );
}

export const getSimilarViewIdByItemId = (itemId: string) => `similar-${itemId}`;

export function getRefreshAt(
  listRefreshAt: string | undefined,
  cards: Pick<Card, 'transmissions'>[] | undefined,
  currentTime: number
) {
  if (!listRefreshAt && !cards) return;

  if (listRefreshAt) return Date.parse(listRefreshAt);

  return cards?.reduce((prev: number | null, current) => {
    if (!current.transmissions?.length) return prev;

    const endTime = current.transmissions.reduce(
      (endTime: null | number, transmission) => {
        const transmissionEndTime = Date.parse(transmission.endTime);

        if (!endTime && transmissionEndTime > currentTime)
          return transmissionEndTime;

        if (endTime && transmissionEndTime)
          return Math.min(endTime, transmissionEndTime);

        return endTime;
      },
      null
    );

    if (!prev && endTime) return endTime;
    if (prev && endTime) return Math.min(prev, endTime);

    return prev;
  }, null);
}
